<script setup>
import ReferralAction from "./ReferralAction";
import ReferralStatus from "../../../common/ReferralStatus";
import {usePortalContentAndDesignStore} from "../../../../stores/partners/portalContentAndDesignStore";
import {computed} from "vue";
import EditableTextField from "../../portal-editable-fields/EditableTextField.vue";

    const props = defineProps({
        recentActivities: {
            type: Array,
            default: () => []
        }
    })

    const portalContentAndDesignStore = usePortalContentAndDesignStore();

    const layoutStyle = computed(() => portalContentAndDesignStore.portalLayoutSettings.portal_layout_layout_style);

</script>

<template>
    <table
        class="table"
        :class="{ 'table-wide': layoutStyle === 'none'}"
    >
        <thead>
        <tr>
            <th>
                <editable-text-field
                    text-type="span"
                    v-model="portalContentAndDesignStore.translationSettings.portal_translation_general_referral"
                ></editable-text-field>
            </th>
            <th>
                <editable-text-field
                    text-type="span"
                    v-model="portalContentAndDesignStore.translationSettings.portal_translation_general_action"
                ></editable-text-field>
            </th>
            <th>
                <editable-text-field
                    text-type="span"
                    v-model="portalContentAndDesignStore.translationSettings.portal_translation_general_reward"
                ></editable-text-field>
            </th>
            <th>
                <editable-text-field
                    text-type="span"
                    v-model="portalContentAndDesignStore.translationSettings.portal_translation_general_status"
                ></editable-text-field>
            </th>
            <th>
                <editable-text-field
                    text-type="span"
                    v-model="portalContentAndDesignStore.translationSettings.portal_translation_general_date"
                ></editable-text-field>
            </th>
        </tr>
            <tr class="h-1"/>
        </thead>
        <tbody>
        <tr
            v-for="referral in recentActivities"
            class="hover:bg-gray-100 hover:bg-opacity-50"
        >
            <td class="whitespace-nowrap">
                <div v-if="referral['multi_tier_affiliate_commission']"
                     class="font-medium group-hover:underline"
                     :class="`group-hover:${portalContentAndDesignStore.getLinkColorClass}`"
                >
                    Referred Partner reward
                </div>
                <router-link
                    v-else-if="referral['email'] || referral['customer_full_name']"
                    :to="`/referral/${referral['customer_id']}`"
                    class="block group"
                >
                    <div
                        class="font-medium group-hover:underline"
                        :class="`group-hover:${portalContentAndDesignStore.getLinkColorClass}`"
                    >
                        {{ referral['customer_full_name'] }}
                    </div>
                    <span v-if="!portalContentAndDesignStore.portalLayoutSettings.portal_general_hide_partner_contact_info"
                          class="opacity-60"
                    >
                        {{ referral['email'] }}
                    </span>
                </router-link>
                <template v-else>-</template>
            </td>


            <td class="whitespace-nowrap">
                <referral-action :action="referral['action']" :text-color="portalContentAndDesignStore.getTextColorClass"/>
            </td>
            <td class="font-medium whitespace-nowrap">
                <tooltip v-if="referral['reward_commission_description']" :content="referral['reward_commission_description']" class="cursor-pointer">
                    {{ referral['currency_amount'] || ' - ' }}
                </tooltip>
                <div v-else>
                    {{ referral['currency_amount'] || ' - ' }}
                </div>
            </td>
            <td class="font-medium whitespace-nowrap">
                <referral-status :status="referral['status']" :archived="referral['is_archived']" :activity="referral" />
            </td>
            <td class="whitespace-nowrap">
                <time
                    class="opacity-60"
                    :datetime="referral['date']"
                >
                    {{ referral['parsed_date_time'] }}
                </time>
            </td>
        </tr>
        </tbody>
    </table>
</template>
